import { FiltersByKeys } from "../../common/components/ActiveFilters/ActiveFilters.utils";

// Filter field keys whose values are user ids and should be shown by name.
const USER_FIELD_LABELS: Record<string, string> = {
	requester_id: "Requester",
	validator_id: "Validator",
};

export const enrichUserActiveFilters = (
	filtersByKeys: FiltersByKeys,
	userNameById: Record<string, string>
): FiltersByKeys => {
	const resolveName = (id: unknown) =>
		userNameById[String(id)] ?? String(id);

	Object.keys(filtersByKeys).forEach((key) => {
		if (!(key in USER_FIELD_LABELS)) {
			return;
		}
		const entry = filtersByKeys[key];
		entry.label = USER_FIELD_LABELS[key];
		entry.value = Array.isArray(entry.value)
			? entry.value.map(resolveName)
			: resolveName(entry.value);
	});

	return filtersByKeys;
};
